import {createContext} from 'react'

const GlobalContext = createContext("");

export {GlobalContext}